import { TableCell, TableRow } from "@mui/material";
import { formatNumber } from "../../utils/format";
import { Body } from "../ui/Typography";
interface FinancialSummaryRowProps {
  label: string;
  englishLabel: string;
  amounts: { [month: string]: number };
  isNegative?: boolean;
}

export const FinancialSummaryRow = ({
  label,
  englishLabel,
  amounts,
  isNegative = false
}: FinancialSummaryRowProps) => {
  return (
    <TableRow className="bg-gray-50 font-bold">
      <TableCell
        className="sticky left-0 z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] bg-gray-50"
        sx={{
          borderBottom: 'none',
          borderRight: '1px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Body>{label}</Body>
      </TableCell>
      <TableCell
        sx={{
          borderBottom: 'none',
          borderRight: '1px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Body>{englishLabel}</Body>
      </TableCell>
      {Object.entries(amounts).map(([month, amount]) => (
        <TableCell
          key={month}
          align="right"
          style={{ minWidth: 150 }}
          sx={{
            borderBottom: 'none',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            '&:last-child': {
              borderRight: 'none'
            }
          }}
        >
          {formatNumber(isNegative ? -amount : amount)}
        </TableCell>
      ))}
    </TableRow>
  );
};